import './prognostics-date-filter'

import { postsByCategory } from '../api'
import pagination from '../pagination'
import select from '../select'
import morePost from '../more-post'
import { prognosticHtml } from './prognostic-markup'

const prognostic = {
  elements: {
    button: document.querySelector('.CardPrognosticWrapper-btn'),
    container: document.querySelector('.CardPrognosticSection-list')
  },
  fieldsToQuery: ['id', 'link', 'tips_info', 'title'],
  getPostsPerPage: () => 12,
  loading: () => `<div class="List-loading"><span></span><span></span><span></span></div>`,

  init: async ({ ...props }) => {
    const filterDateActive = document.querySelector('.prognostics-filter-date__list-item.--is-active')
    const filterDate =
      props.filterDate
        || filterDateActive ? filterDateActive.dataset.filterDate || 'all' : 'all'
    const url = new URL(window.location)
    const container = prognostic.elements.container

    if (!document.querySelector('.CardPrognosticSection-title')) {
      return
    }

    if (container && !container.parentElement.querySelector('.List-loading')) {
      container.parentElement.prepend(
        document.createRange().createContextualFragment(prognostic.loading())
      );
    }

    if (props.forceLoad && container) {
      container.classList.add('loading')
      container.parentElement.classList.add('loading')
    }

    const { data, totalPages, pageCurrent, categoryId } = await postsByCategory({
      fields: prognostic.fieldsToQuery,
      filterDate,
      ...props,
      postType: postType,
      perPage: prognostic.getPostsPerPage()
    })

    const list = await data

    if (props.forceLoad && container) {
      container.innerHTML = (list.length > 0)
                          ? await prognosticHtml.render({data: list})
                          : '<h2>' + clubei18n.nenhumresultado + '</h2>'

      container.classList.remove('loading')
      container.parentElement.classList.remove('loading')
    }

    // set category
    if (!document.querySelector('#categoryShowPrognosticBlock')) {
      const newInput = document.createElement('input')
      newInput.setAttribute('id', 'categoryShowPrognosticBlock')
      newInput.setAttribute('type', 'hidden')
      newInput.setAttribute('value', categoryId)
      document.querySelector('.CardPrognosticWrapper').prepend(newInput)
    } else {
      document.querySelector('#categoryShowPrognosticBlock').setAttribute('value', categoryId)
    }

    url.searchParams.set('pagina', pageCurrent)
    url.searchParams.set('filterDate', filterDate)
    window.history.pushState({}, '', url)

    if (prognostic.elements.button) {
      prognostic.elements.button.classList.remove('loading')
    }

    if (totalPages === pageCurrent && prognostic.elements.button) {
      prognostic.elements.button.style.display = 'none'
    }

    pagination.init({
      totalPages,
      pageCurrent,
      categoryId,
      postType: 'prognostico',
      wrapper: '.CardPrognosticSection',
      targetContainer: '.ListPrognosticWrapper',
      forceLoad: props.forceLoad
    })
  }
}

const isMobile = window.innerWidth < 576
const url = new URL(window.location)
const category = document.querySelector('#categoryShow')
  ? document.querySelector('#categoryShow').value
  : document.querySelector('#listSelectionPrognosticBlock')
  ? document.querySelector('#listSelectionPrognosticBlock').value
  : null
const pageCurrent = url.searchParams.get('pagina')
// const firstPage = Number(pageCurrent) === 1 ? 0 : Number(pageCurrent)
const postType = document.querySelector('#postTypePrognosticBlock')
  ? document.querySelector('#postTypePrognosticBlock').value
  : 'palpites'
const layout = 'prognostico'

const initialState = {
  id: Number(category) || 0,
  pageCurrent: Number(pageCurrent) || 1,
  perPage: 12,
  // offset: isMobile ? firstPage * 3 - 3 : '',
  typePost: postType,
  layout: layout,
  forceLoad: false
}

prognostic.init({ ...initialState })
if (select && document.querySelector('.CardPrognosticSection-title')) {
  select.init({ ...initialState, wrapper: '.CardPrognosticSection-title' })
  morePost.init({ ...initialState, fields: prognostic.fieldsToQuery })
}

export default prognostic
